const UtilMoney = require("./UtilMoney").default;
const EntityService = require("../services/entityService").default;
const UtilDateTime = require("./UtilDateTime").default;

class UtilCapaJobPDF {
  static logoCache = null;

  static async carregarLogo() {
    if (this.logoCache) return this.logoCache;

    try {
      const response = await fetch("/img/logo-delta-ducon.png");
      if (!response.ok) {
        console.error("Erro ao buscar PNG:", response.status);
        return null;
      }
      
      const blob = await response.blob();
      console.log("PNG carregado, tamanho:", blob.size);
      
      // Converte blob para base64
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.logoCache = reader.result;
          console.log("Logo PNG convertido para base64, tamanho:", this.logoCache.length);
          resolve(this.logoCache);
        };
        reader.onerror = (error) => {
          console.error("Erro ao ler blob:", error);
          resolve(null);
        };
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Erro ao carregar logo PNG:", error);
      return null;
    }
  }

  static async gerarCapaJob(dado) {
    try {
      var pdfMake = require("pdfmake/build/pdfmake.js");
      var pdfFonts = await require("pdfmake/build/vfs_fonts.js");

      pdfMake.vfs = pdfFonts.pdfMake.vfs;

      const logo = await this.carregarLogo();
      console.log("Logo para PDF:", logo ? "OK" : "NULL");
      
      if (!logo) {
        throw new Error("Não foi possível carregar o logo");
      }
      
      const dadosEnriquecidos = await this.enriquecerDados(dado);
      const dataCapa = this.criarDefinicaoCapa(dadosEnriquecidos, logo);
      pdfMake.createPdf(dataCapa).download(`Capa_Job_${dado?.codigo || "job"}.pdf`);
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      throw error;
    }
  }

  static async enriquecerDados(dado) {
    const dados = { ...dado };

    const clienteId = dados?.cliente?.id || dados?.clienteID;
    if (
      clienteId &&
      (!dados?.cliente?.endereco || !dados?.cliente?.cnpj || !dados?.cliente?.municipio)
    ) {
      try {
        const clienteService = new EntityService("Cliente");
        const clienteResponse = await clienteService.getById(clienteId);
        const clienteCompleto = clienteResponse?.data?.data;
        if (clienteCompleto) {
          dados.cliente = { ...clienteCompleto, ...dados.cliente };
        }
      } catch (error) {
        console.error("Erro ao carregar cliente completo:", error);
      }
    }

    const solicitacaoId =
      dados?.solicitacaoDeOrcamento?.id || dados?.solicitacaoDeOrcamentoID;
    if (solicitacaoId) {
      try {
        const solicitacaoService = new EntityService("SolicitacaoDeOrcamento");
        const solicitacaoResponse = await solicitacaoService.getById(solicitacaoId);
        const solicitacaoCompleta = solicitacaoResponse?.data?.data;

        if (solicitacaoCompleta && solicitacaoCompleta !== "Não encontrado") {
          // Preserva toda a estrutura da API (com _currentData e childrens)
          dados.solicitacaoDeOrcamento = solicitacaoCompleta;
        }
      } catch (error) {
        console.error("Erro ao carregar solicitacao completa:", error);
      }
    }

    const orcamentistaNomeAtual =
      dados?.solicitacaoDeOrcamento?._currentData?.orcamentistaNome ||
      dados?.solicitacaoDeOrcamento?.orcamentistaNome ||
      "";

    if (solicitacaoId && !orcamentistaNomeAtual) {
      try {
        const salesOrderService = new EntityService("SalesOrder");
        const salesOrderResponse = await salesOrderService.getById(solicitacaoId);
        const salesOrderCompleta = salesOrderResponse?.data?.data;

        if (salesOrderCompleta && salesOrderCompleta !== "Não encontrado") {
          dados.solicitacaoDeOrcamento = {
            ...salesOrderCompleta,
            ...dados.solicitacaoDeOrcamento,
          };
        }
      } catch (error) {
        console.error("Erro ao carregar SalesOrder:", error);
      }
    }

    const contatoComercialId =
      dados?.solicitacaoDeOrcamentoContatoComercialID ||
      dados?.solicitacaoDeOrcamento?._currentData?.contatoComercial ||
      dados?.solicitacaoDeOrcamento?.contatoComercial;
    if (contatoComercialId) {
      try {
        const contatoService = new EntityService("ClienteContatos");
        const contatoResponse = await contatoService.getById(contatoComercialId);
        const contatoCompleto = contatoResponse?.data?.data;
        if (contatoCompleto) {
          dados.contatoComercialDetalhe = contatoCompleto;
        }
      } catch (error) {
        console.error("Erro ao carregar contato comercial:", error);
      }
    }

    const contatoTecnicoId =
      dados?.solicitacaoDeOrcamentoContatoTecnicoID ||
      dados?.solicitacaoDeOrcamento?._currentData?.contatoTecnico ||
      dados?.solicitacaoDeOrcamento?.contatoTecnico;
    if (contatoTecnicoId) {
      try {
        const contatoService = new EntityService("ClienteContatos");
        const contatoResponse = await contatoService.getById(contatoTecnicoId);
        const contatoCompleto = contatoResponse?.data?.data;
        if (contatoCompleto) {
          dados.contatoTecnicoDetalhe = contatoCompleto;
        }
      } catch (error) {
        console.error("Erro ao carregar contato tecnico:", error);
      }
    }

    const revisoesComerciais =
      dados?.solicitacaoDeOrcamento?._currentData?.revisoesComerciais ||
      dados?.solicitacaoDeOrcamento?.revisoesComerciais ||
      [];
    const revisaoComercialId = Array.isArray(revisoesComerciais)
      ? revisoesComerciais[0]
      : revisoesComerciais;

    if (revisaoComercialId) {
      try {
        const revisaoService = new EntityService("SalesOrderRevisao");
        const revisaoResponse = await revisaoService.getById(revisaoComercialId);
        const revisaoCompleta = revisaoResponse?.data?.data;

        if (revisaoCompleta && revisaoCompleta !== "Não encontrado") {
          dados.revisaoComercialDetalhe = revisaoCompleta;
        }
      } catch (error) {
        console.error("Erro ao carregar revisao comercial:", error);
      }
    }

    return dados;
  }

  static criarDefinicaoCapa(dado, logo) {
    console.log("criarDefinicaoCapa - logo recebido:", logo ? logo.substring(0, 50) + "..." : "NULL");
    
    const dataAtual = new Date();
    const dia = String(dataAtual.getDate()).padStart(2, "0");
    const mes = String(dataAtual.getMonth() + 1).padStart(2, "0");
    const ano = dataAtual.getFullYear();
    const dataEmissao = `${dia}/${mes}/${ano}`;

    const formatNumberPt = (value) => {
      if (value === null || value === undefined || value === "") return "";
      if (typeof value === "number") {
        return value.toLocaleString("pt-BR");
      }
      return value;
    };
    const hasValue = (value) => value !== null && value !== undefined && value !== "";

    const clienteCodigo = dado?.cliente?.codigo || dado?.clienteCodigo || "";
    const clienteNome = dado?.cliente?.nomeFantasia || dado?.cliente?.nome || dado?.clienteNome || "";
    
    // Monta endereço completo do cliente
    const clienteEndereco = dado?.cliente?.faturamentoEndereco 
      ? `${dado.cliente.faturamentoEndereco}${dado.cliente.faturamentoNumero ? ', ' + dado.cliente.faturamentoNumero : ''}${dado.cliente.faturamentoBairro && dado.cliente.faturamentoBairro !== '---' ? ' - ' + dado.cliente.faturamentoBairro : ''}`
      : (dado?.cliente?.endereco || "");
    
    const clienteMunicipio = dado?.cliente?.faturamentoCidadeNome 
      ? `${dado.cliente.faturamentoCidadeNome}${dado.cliente.faturamentoEstadoNome ? ' - ' + dado.cliente.faturamentoEstadoNome : ''}${dado.cliente.faturamentoCEP ? ' - CEP: ' + dado.cliente.faturamentoCEP : ''}`
      : (dado?.cliente?.municipio || "");
    
    const clienteCNPJ = dado?.cliente?.cnpj || "";
    const clienteInscricaoEstadual = dado?.cliente?.inscricaoEstadual || "";
    
    // Estrutura da solicitacao pode estar em diferentes lugares
    const solicitacao = dado?.solicitacaoDeOrcamento?._currentData || dado?.solicitacaoDeOrcamento || {};
    const childrens = dado?.solicitacaoDeOrcamento?.childrens || {};

    // Dados do vendedor
    const vendedorNome =
      solicitacao?.vendedorNome ||
      dado?.solicitacaoDeOrcamentoVendedorNome ||
      dado?.cliente?.vendedorNome ||
      dado?.vendedorNome ||
      "";

    // Dados dos contatos
    const contatoComercialNome =
      solicitacao?.contatoComercialNome ||
      dado?.solicitacaoDeOrcamentoContatoComercialNome ||
      dado?.contatoComercialDetalhe?.nome ||
      "";
    const contatoComercialEmail =
      solicitacao?.contatoComercialEmail ||
      dado?.contatoComercialDetalhe?.email ||
      "";
    const contatoComercialTelefone =
      solicitacao?.contatoComercialTelefone ||
      dado?.contatoComercialDetalhe?.telefone ||
      "";
    const contatoComercialCelular =
      solicitacao?.contatoComercialCelular ||
      dado?.contatoComercialDetalhe?.celular ||
      "";

    const contatoTecnicoNome =
      solicitacao?.contatoTecnicoNome ||
      dado?.solicitacaoDeOrcamentoContatoTecnicoNome ||
      dado?.contatoTecnicoDetalhe?.nome ||
      "";
    const contatoTecnicoEmail =
      solicitacao?.contatoTecnicoEmail ||
      dado?.contatoTecnicoDetalhe?.email ||
      "";
    const contatoTecnicoTelefone =
      solicitacao?.contatoTecnicoTelefone ||
      dado?.contatoTecnicoDetalhe?.telefone ||
      "";
    const contatoTecnicoCelular =
      solicitacao?.contatoTecnicoCelular ||
      dado?.contatoTecnicoDetalhe?.celular ||
      "";

    // Dados do orcamentista
    const orcamentistaNome =
      solicitacao?.orcamentistaNome ||
      dado?.solicitacaoDeOrcamentoOrcamentistaNome ||
      dado?.solicitacaoDeOrcamento?.orcamentistaNome ||
      dado?.solicitacaoDeOrcamento?._currentData?.orcamentistaNome ||
      "";
    
    // Dados da revisão comercial
    const revisaoComercial =
      dado?.revisaoComercialDetalhe ||
      childrens?.SalesOrderRevisao ||
      {};
    const itemComISS = (dado?.itens || []).find((item) => item?.porcentagemISS !== undefined);
    const itemComICMS = (dado?.itens || []).find((item) => item?.porcentagemICMS !== undefined);
    const itemComIPI = (dado?.itens || []).find((item) => item?.porcentagemIPI !== undefined);
    const porcentagemPIS = formatNumberPt(revisaoComercial?.porcentagemPIS || "");
    const porcentagemCOFINS = formatNumberPt(revisaoComercial?.porcentagemCOFINS || "");
    const porcentagemISS = formatNumberPt(revisaoComercial?.porcentagemISS || itemComISS?.porcentagemISS || "");
    const porcentagemICMS = formatNumberPt(revisaoComercial?.porcentagemICMSVenda || itemComICMS?.porcentagemICMS || "");
    const porcentagemIPI = formatNumberPt(revisaoComercial?.pocentagemIPIVenda || itemComIPI?.porcentagemIPI || "");
    const ki = formatNumberPt(revisaoComercial?.ki || "");
    const kv = formatNumberPt(revisaoComercial?.kv || "");
    
    // Tipo de equipamento
    const tipoEquipamento =
      solicitacao?._mirror_tipo ||
      childrens?.TipoDeEquipamento?.description ||
      dado?.solicitacaoDeOrcamentoTipoDeEquipamentoDescricao ||
      "";

    const condicaoPagamento =
      dado?.condicaoDePagamento ||
      dado?.condicaoPagamento ||
      solicitacao?.condicaoDePagamento ||
      "";

    const responsavelNome =
      dado?.responsavelNome ||
      dado?.responsavel ||
      dado?.colaborador?.[0]?.name ||
      dado?.colaborador?.nome ||
      dado?.gestorNome ||
      dado?.coordenadorNome ||
      dado?.comercialNome ||
      "";

    const transporteDescricao =
      dado?.transporteDescricaoCompleta ||
      dado?.transporte?.descricaoCompleta ||
      dado?.transporte?.descricao ||
      dado?.transporteDescricao ||
      "Por conta do cliente.";

    const cartaFiancaNotaPromissoria =
      dado?.cartaFiancaNotaPromissoria ||
      dado?.cartaFianca ||
      dado?.notaPromissoria ||
      "NÃO";

    const reajusteDescricao = dado?.reajuste || dado?.reajusteDescricao || "NÃO";

    const inspecaoDescricao =
      dado?.inspecao ||
      dado?.inspecaoDescricao ||
      (dado?.naoTemInspecao ? "NÃO" : "SIM");

    const multaDescricao =
      dado?.multa ||
      dado?.multaDescricao ||
      dado?.multasContratuaisDescricao ||
      "";

    const valorAcrescimos = dado?.acrescimos || 0;
    const valorDescontos = dado?.descontos || 0;

    // Calcula totais dos itens
    const totalItens = (dado?.itens || []).length;
    const somaValores = (dado?.itens || []).reduce((soma, item) => soma + (item?.precoTotal || 0), 0);
    const somaISS = (dado?.itens || []).reduce((soma, item) => soma + (item?.valorISS || 0), 0);
    const somaIPI = (dado?.itens || []).reduce((soma, item) => soma + (item?.valorIPI || 0), 0);
    const somaICMS = (dado?.itens || []).reduce((soma, item) => soma + (item?.valorICMS || 0), 0);

    // Mapeamento de datas formatadas
    const dataEnvioAprovacaoContratualFormatada = dado?.dataEnvioAprovacaoContratualFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataEnvioAprovacaoContratual}) || "";
    const dataEnvioAprovacaoEfetivaFormatada = dado?.dataEnvioAprovacaoEfetivaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataEnvioAprovacaoEfetiva}) || "";
    const dataAprovacaoPrevistaFormatada = dado?.dataAprovacaoPrevistaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataAprovacaoPrevista}) || "";
    const dataAprovacaoEfetivaFormatada = dado?.dataAprovacaoEfetivaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataAprovacaoEfetiva}) || "";
    const dataInspecaoPrevistaFormatada = dado?.dataInspecaoPrevistaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataInspecaoPrevista}) || "";
    const dataInspecaoEfetivaFormatada = dado?.dataInspecaoEfetivaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataInspecaoEfetiva}) || "";
    const dataEntregaFiscalPrevistaFormatada = dado?.dataEntregaFiscalPrevistaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataEntregaFiscalPrevista}) || "";
    const dataEntregaFiscalEfetivaFormatada = dado?.dataEntregaFiscalEfetivaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataEntregaFiscalEfetiva}) || "";
    const dataMontagemContratualFormatada = dado?.dataMontagemContratualFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataMontagemContratual}) || "";
    const dataMontagemEfetivaFormatada = dado?.dataMontagemEfetivaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataMontagemEfetiva}) || "";
    const dataStartupPrevistaFormatada = dado?.dataStartupPrevistaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataStartupPrevista}) || "";
    const dataStartupEfetivaFormatada = dado?.dataStartupEfetivaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataStartupEfetiva}) || "";
    const dataFinalContratualFormatada = dado?.dataFinalContratualFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataFinalContratual}) || "";
    const dataFinalEfetivaFormatada = dado?.dataFinalEfetivaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataFinalEfetiva}) || "";

    const docDef = {
      pageSize: "A4",
      pageMargins: [30, 30, 30, 30],
      images: {
        logoImage: logo
      },
      content: [
        // LOGO E JOB - CABEÇALHO SUPERIOR
        {
          columns: [
            {
              width: "50%",
              image: 'logoImage',
              fit: [200, 80],
              alignment: "left",
            },
            {
              width: "50%",
              text: [
                { text: "JOB: ", bold: true, fontSize: 14 },
                { text: dado?.codigo || "", bold: true, fontSize: 16 },
              ],
              alignment: "right",
              margin: [0, 10, 0, 0],
            },
          ],
          margin: [0, 0, 0, 20],
        },

        // LINHA SEPARADORA
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 535,
              y2: 0,
              lineWidth: 1,
              lineColor: "#000000",
            },
          ],
          margin: [0, 0, 0, 15],
        },

        // INÍCIO DO CABEÇALHO - DADOS DO CLIENTE
        {
          table: {
            widths: ["*"],
            body: [
              [
                {
                  columns: [
                    {
                      width: "50%",
                      text: [
                        { text: "Cliente", bold: true, fontSize: 9 },
                        { text: "...........: ", fontSize: 9 },
                        {
                          text: `${clienteCodigo} - ${clienteNome}`,
                          bold: true,
                          fontSize: 10,
                        },
                      ],
                    },
                    {
                      width: "50%",
                      text: [
                        { text: "JOB", bold: true, fontSize: 9 },
                        { text: ": ", fontSize: 9 },
                        {
                          text: dado?.codigo || "",
                          bold: true,
                          fontSize: 12,
                        },
                      ],
                    },
                  ],
                  margin: [0, 5, 0, 5],
                },
              ],
              [
                {
                  columns: [
                    {
                      width: "50%",
                      text: [
                        { text: "Endereço", bold: true, fontSize: 9 },
                        { text: ".........: ", fontSize: 9 },
                        { text: clienteEndereco, fontSize: 10 },
                      ],
                    },
                    {
                      width: "50%",
                      text: [
                        { text: "C.G.C.", bold: true, fontSize: 9 },
                        { text: "...............: ", fontSize: 9 },
                        { text: clienteCNPJ, fontSize: 10 },
                      ],
                    },
                  ],
                  margin: [0, 3, 0, 3],
                },
              ],
              [
                {
                  columns: [
                    {
                      width: "50%",
                      text: [
                        { text: "Município", bold: true, fontSize: 9 },
                        { text: ".......: ", fontSize: 9 },
                        { text: clienteMunicipio, fontSize: 10 },
                      ],
                    },
                    {
                      width: "50%",
                      text: [
                        { text: "Inscr.Estadual", bold: true, fontSize: 9 },
                        { text: "........: ", fontSize: 9 },
                        { text: clienteInscricaoEstadual, fontSize: 10 },
                      ],
                    },
                  ],
                  margin: [0, 3, 0, 3],
                },
              ],
            ],
          },
          layout: "noBorders",
          margin: [0, 0, 0, 10],
        },

        // LINHA SEPARADORA
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 535,
              y2: 0,
              lineWidth: 0.5,
              lineColor: "#000000",
            },
          ],
          margin: [0, 0, 0, 10],
        },

        // SEÇÃO CONTATOS E DATAS
        {
          table: {
            widths: ["25%", "25%", "25%", "25%"],
            body: [
              [
                {
                  text: [
                    { text: "Contato Coml.:\n", bold: true, fontSize: 8 },
                    { text: contatoComercialNome, fontSize: 8 },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "e_mail Coml...:\n", bold: true, fontSize: 8 },
                    {
                      text: contatoComercialEmail,
                      fontSize: 7,
                    },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Contato Tec...:\n", bold: true, fontSize: 8 },
                    { text: contatoTecnicoNome, fontSize: 8 },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "e_mail Tec......:\n", bold: true, fontSize: 8 },
                    {
                      text: contatoTecnicoEmail,
                      fontSize: 7,
                    },
                  ],
                  margin: [3, 3, 3, 3],
                },
              ],
              [
                {
                  text: [
                    { text: "DataAbertura..: ", bold: true, fontSize: 8 },
                    {
                      text: dado?.dataAberturaFormatada || "",
                      fontSize: 8,
                    },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Data Encerramento: ", bold: true, fontSize: 8 },
                    {
                      text: dado?.dataEncerramentoFormatada || "",
                      fontSize: 8,
                    },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Proposta.........: ", bold: true, fontSize: 8 },
                    { text: solicitacao?.codigo || "", fontSize: 8 },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Pedido Cliente.......: ", bold: true, fontSize: 8 },
                    { text: dado?.clientePedidoDeCompra || "", fontSize: 8 },
                  ],
                  margin: [3, 3, 3, 3],
                },
              ],
              [
                {
                  text: [
                    { text: "Vendedor.......: ", bold: true, fontSize: 8 },
                    { text: vendedorNome, fontSize: 8 },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Orcamentista.: ", bold: true, fontSize: 8 },
                    { text: orcamentistaNome, fontSize: 8 },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Fone/Cel Coml.: ", bold: true, fontSize: 8 },
                    {
                      text: contatoComercialTelefone + (contatoComercialCelular ? ' / ' + contatoComercialCelular : ''),
                      fontSize: 8,
                    },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Fone/Cel Tec.: ", bold: true, fontSize: 8 },
                    {
                      text: contatoTecnicoTelefone + (contatoTecnicoCelular ? ' / ' + contatoTecnicoCelular : ''),
                      fontSize: 8,
                    },
                  ],
                  margin: [3, 3, 3, 3],
                },
              ],
              [
                {
                  text: [
                    { text: "Responsável..: ", bold: true, fontSize: 8 },
                    { text: responsavelNome, fontSize: 8 },
                  ],
                  margin: [3, 3, 3, 3],
                },
                { text: "", margin: [3, 3, 3, 3] },
                { text: "", margin: [3, 3, 3, 3] },
                { text: "", margin: [3, 3, 3, 3] },
              ],
            ],
          },
          layout: "noBorders",
          margin: [0, 0, 0, 10],
        },

        // LINHA SEPARADORA
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 535,
              y2: 0,
              lineWidth: 0.5,
              lineColor: "#000000",
            },
          ],
          margin: [0, 0, 0, 10],
        },

        // INFORMAÇÕES DA REVISÃO COMERCIAL
        {
          table: {
            widths: ["12.5%", "12.5%", "12.5%", "12.5%", "12.5%", "12.5%", "12.5%", "12.5%"],
            body: [
              [
                {
                  text: "Percentuais e Índices do Orçamento",
                  bold: true,
                  fontSize: 9,
                  colSpan: 8,
                  alignment: "center",
                  fillColor: "#e0e0e0",
                  margin: [3, 5, 3, 5],
                },
                {}, {}, {}, {}, {}, {}, {}
              ],
              [
                {
                  text: [
                    { text: "PIS\n", bold: true, fontSize: 7 },
                    { text: hasValue(porcentagemPIS) ? porcentagemPIS + "%" : "-", fontSize: 8 },
                  ],
                  alignment: "center",
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "COFINS\n", bold: true, fontSize: 7 },
                    { text: hasValue(porcentagemCOFINS) ? porcentagemCOFINS + "%" : "-", fontSize: 8 },
                  ],
                  alignment: "center",
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "ISS\n", bold: true, fontSize: 7 },
                    { text: hasValue(porcentagemISS) ? porcentagemISS + "%" : "-", fontSize: 8 },
                  ],
                  alignment: "center",
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "ICMS\n", bold: true, fontSize: 7 },
                    { text: hasValue(porcentagemICMS) ? porcentagemICMS + "%" : "-", fontSize: 8 },
                  ],
                  alignment: "center",
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "IPI\n", bold: true, fontSize: 7 },
                    { text: hasValue(porcentagemIPI) ? porcentagemIPI + "%" : "-", fontSize: 8 },
                  ],
                  alignment: "center",
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Ki\n", bold: true, fontSize: 7 },
                    { text: hasValue(ki) ? ki.toString() : "-", fontSize: 8 },
                  ],
                  alignment: "center",
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Kv\n", bold: true, fontSize: 7 },
                    { text: hasValue(kv) ? kv.toString() : "-", fontSize: 8 },
                  ],
                  alignment: "center",
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Valor Orç.\n", bold: true, fontSize: 7 },
                    { text: UtilMoney.toR$BRL(dado?.solicitacaoDeOrcamento?._mirror_valor_sIPI_cICMS || 0), fontSize: 7 },
                  ],
                  alignment: "center",
                  margin: [3, 3, 3, 3],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
            hLineColor: "#cccccc",
            vLineColor: "#cccccc",
          },
          margin: [0, 0, 0, 15],
        },

        // SEÇÃO DE VALORES
        {
          table: {
            widths: ["40%", "60%"],
            body: [
              [
                { text: "Valor ISS", bold: true, fontSize: 9 },
                {
                  text: UtilMoney.toR$BRL(somaISS),
                  alignment: "right",
                  fontSize: 9,
                },
              ],
              [
                { text: "Valor IPI", bold: true, fontSize: 9 },
                {
                  text: UtilMoney.toR$BRL(somaIPI),
                  alignment: "right",
                  fontSize: 9,
                },
              ],
              [
                { text: "Valor ICMS", bold: true, fontSize: 9 },
                {
                  text: UtilMoney.toR$BRL(somaICMS),
                  alignment: "right",
                  fontSize: 9,
                },
              ],
              [
                { text: "Preço s/ IPI c/ ICMS", bold: true, fontSize: 9 },
                {
                  text: UtilMoney.toR$BRL(somaValores),
                  alignment: "right",
                  fontSize: 9,
                },
              ],
              [
                { text: "Preço c/ IPI c/ ICMS", bold: true, fontSize: 9 },
                {
                  text: UtilMoney.toR$BRL(somaValores + somaIPI),
                  alignment: "right",
                  fontSize: 9,
                },
              ],
              [
                { text: "Multas Contratuais", bold: true, fontSize: 9 },
                {
                  text: UtilMoney.toR$BRL(0),
                  alignment: "right",
                  fontSize: 9,
                },
              ],
              [
                {
                  text: "Valor Líquido",
                 bold: true,
                  fontSize: 10,
                  fillColor: "#f0f0f0",
                },
                {
                  text: UtilMoney.toR$BRL(dado?.valorAtual || somaValores),
                  alignment: "right",
                  fontSize: 10,
                  bold: true,
                  fillColor: "#f0f0f0",
                },
              ],
            ],
          },
          layout: {
            hLineWidth: (i, node) => {
              if (i === 0 || i === node.table.body.length) return 1;
              if (i === node.table.body.length - 1) return 1.5;
              return 0.5;
            },
            vLineWidth: () => 0,
            hLineColor: () => "#cccccc",
          },
          margin: [0, 0, 0, 15],
        },

        // DESCRIÇÃO
        {
          text: [
            { text: "Descrição.......: ", bold: true, fontSize: 9 },
            { text: dado?.descricao || "", fontSize: 9 },
          ],
          margin: [0, 0, 0, 15],
        },

        // OBSERVAÇÕES
        {
          text: [
            { text: "Observações....: ", bold: true, fontSize: 9 },
            { text: dado?.observacao || "", fontSize: 9 },
          ],
          margin: [0, 0, 0, 15],
        },

        // CONDIÇÕES DE PAGAMENTO
        {
          text: [
            { text: "Cond.Pagto.....: ", bold: true, fontSize: 9 },
            { text: condicaoPagamento, fontSize: 9 },
          ],
          margin: [0, 0, 0, 15],
        },

        // EQUIPAMENTO E CONDIÇÕES
        {
          table: {
            widths: ["25%", "25%", "25%", "25%"],
            body: [
              [
                {
                  text: [
                    { text: "Equipamento..: ", bold: true, fontSize: 8 },
                    { text: tipoEquipamento, fontSize: 8 },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  colSpan: 2,
                  text: [
                    {
                      text: "NÃO HÁ RESTRIÇÃO SOBRE EMISSÃO DE BOLETO.",
                      bold: true,
                      fontSize: 8,
                    },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {},
              ],
            ],
          },
          layout: "noBorders",
          margin: [0, 0, 0, 10],
        },

        // LINHA SEPARADORA
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 535,
              y2: 0,
              lineWidth: 1,
              lineColor: "#000000",
            },
          ],
          margin: [0, 0, 0, 10],
        },

        // TABELA DE ITENS
        {
          table: {
            headerRows: 1,
            widths: ["4%", "32%", "8%", "10%", "6%", "6%", "6%", "10%", "9%", "9%"],
            body: [
              [
                {
                  text: "It",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
                {
                  text: "Descrição do Item",
                  bold: true,
                  fontSize: 8,
                  alignment: "left",
                },
                {
                  text: "Quant.",
                  bold: true,
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text: "Valor Total",
                  bold: true,
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text: "IPI",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
                {
                  text: "ISS",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
                {
                  text: "ICMS",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
                {
                  text: "Base ICMS/ISS",
                  bold: true,
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text: "Prazo Entrega",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
                {
                  text: "Class. Fiscal",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
              ],
              ...this.criarLinhasItens(dado?.itens || [], tipoEquipamento),
            ],
          },
          layout: {
            hLineWidth: (i, node) => {
              if (i === 0 || i === 1 || i === node.table.body.length) return 1;
              return 0.5;
            },
            vLineWidth: () => 0.5,
            hLineColor: "#000000",
            vLineColor: "#cccccc",
          },
          margin: [0, 0, 0, 15],
        },

        {
          text: `Total: ${UtilMoney.toR$BRL(somaValores)}`,
          fontSize: 9,
          alignment: "right",
          margin: [0, -10, 0, 10],
        },

        // LINHA SEPARADORA
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 535,
              y2: 0,
              lineWidth: 1,
              lineColor: "#000000",
            },
          ],
          margin: [0, 0, 0, 10],
        },

        // TABELA DE PRAZOS
        {
          table: {
            headerRows: 1,
            widths: ["16%", "26%", "16%", "12%", "12%", "10%", "8%"],
            body: [
              [
                {
                  text: "Vencimento",
                  bold: true,
                  fontSize: 8,
                },
                {
                  text: "Descrição",
                  bold: true,
                  fontSize: 8,
                },
                {
                  text: "Valor Parcela",
                  bold: true,
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text: "Liquidação",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
                {
                  text: "Valor Pago",
                  bold: true,
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text: "Ult.Alteração",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
                {
                  text: "Stat",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
              ],
              ...this.criarLinhasPrazos(dado?.lancamentos || []),
            ],
          },
          layout: {
            hLineWidth: (i, node) => {
              if (i === 0 || i === 1 || i === node.table.body.length) return 1;
              return 0.5;
            },
            vLineWidth: () => 0.5,
            hLineColor: "#000000",
            vLineColor: "#cccccc",
          },
          margin: [0, 0, 0, 15],
        },

        {
          text: `Total: ${UtilMoney.toR$BRL(somaValores)}  |  Acréscimos: ${UtilMoney.toR$BRL(valorAcrescimos)}  |  Descontos: ${UtilMoney.toR$BRL(valorDescontos)}`,
          fontSize: 8,
          alignment: "right",
          margin: [0, -10, 0, 10],
        },

        // LINHA SEPARADORA
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 535,
              y2: 0,
              lineWidth: 1,
              lineColor: "#000000",
            },
          ],
          margin: [0, 10, 0, 15],
        },

        // DATAS DO JOB
        {
          text: "DATAS DO JOB",
          bold: true,
          fontSize: 10,
          margin: [0, 0, 0, 10],
        },

        {
          table: {
            widths: ["33%", "33%", "34%"],
            body: [
              // Envio para Aprovação
              [
                {
                  stack: [
                    {
                      text: "Envio para Aprovação",
                      bold: true,
                      fontSize: 8,
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: [
                        { text: "Contratual: ", bold: true, fontSize: 7 },
                        {
                          text: dataEnvioAprovacaoContratualFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 3],
                    },
                    {
                      text: [
                        { text: "Efetiva: ", bold: true, fontSize: 7 },
                        {
                          text: dataEnvioAprovacaoEfetivaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [1, 1, 1, 1],
                  borderColor: "#cccccc",
                  margin: [5, 5, 5, 5],
                },
                // Aprovação
                {
                  stack: [
                    {
                      text: "Aprovação",
                      bold: true,
                      fontSize: 8,
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: [
                        { text: "Prevista: ", bold: true, fontSize: 7 },
                        {
                          text: dataAprovacaoPrevistaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 3],
                    },
                    {
                      text: [
                        { text: "Efetiva: ", bold: true, fontSize: 7 },
                        {
                          text: dataAprovacaoEfetivaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [1, 1, 1, 1],
                  borderColor: "#cccccc",
                  margin: [5, 5, 5, 5],
                },
                // Inspeção
                {
                  stack: [
                    {
                      text: "Inspeção",
                      bold: true,
                      fontSize: 8,
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: [
                        { text: "Prevista: ", bold: true, fontSize: 7 },
                        {
                          text: dataInspecaoPrevistaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 3],
                    },
                    {
                      text: [
                        { text: "Efetiva: ", bold: true, fontSize: 7 },
                        {
                          text: dataInspecaoEfetivaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [1, 1, 1, 1],
                  borderColor: "#cccccc",
                  margin: [5, 5, 5, 5],
                },
              ],
              // Entrega Fiscal
              [
                {
                  stack: [
                    {
                      text: "Entrega Fiscal",
                      bold: true,
                      fontSize: 8,
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: [
                        { text: "Prevista: ", bold: true, fontSize: 7 },
                        {
                          text: dataEntregaFiscalPrevistaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 3],
                    },
                    {
                      text: [
                        { text: "Efetiva: ", bold: true, fontSize: 7 },
                        {
                          text: dataEntregaFiscalEfetivaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [1, 1, 1, 1],
                  borderColor: "#cccccc",
                  margin: [5, 5, 5, 5],
                },
                // Montagem
                {
                  stack: [
                    {
                      text: "Montagem",
                      bold: true,
                      fontSize: 8,
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: [
                        { text: "Contratual: ", bold: true, fontSize: 7 },
                        {
                          text: dataMontagemContratualFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 3],
                    },
                    {
                      text: [
                        { text: "Efetiva: ", bold: true, fontSize: 7 },
                        {
                          text: dataMontagemEfetivaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [1, 1, 1, 1],
                  borderColor: "#cccccc",
                  margin: [5, 5, 5, 5],
                },
                // Start-UP
                {
                  stack: [
                    {
                      text: "Start-UP",
                      bold: true,
                      fontSize: 8,
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: [
                        { text: "Prevista: ", bold: true, fontSize: 7 },
                        {
                          text: dataStartupPrevistaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 3],
                    },
                    {
                      text: [
                        { text: "Efetiva: ", bold: true, fontSize: 7 },
                        {
                          text: dataStartupEfetivaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [1, 1, 1, 1],
                  borderColor: "#cccccc",
                  margin: [5, 5, 5, 5],
                },
              ],
              // Entrega Final Contratual
              [
                {
                  stack: [
                    {
                      text: "Entrega Final Contratual",
                      bold: true,
                      fontSize: 8,
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: [
                        { text: "Contratual: ", bold: true, fontSize: 7 },
                        {
                          text: dataFinalContratualFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 3],
                    },
                    {
                      text: [
                        { text: "Efetiva: ", bold: true, fontSize: 7 },
                        {
                          text: dataFinalEfetivaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [1, 1, 1, 1],
                  borderColor: "#cccccc",
                  margin: [5, 5, 5, 5],
                },
                { text: "", border: [0, 0, 0, 0] },
                { text: "", border: [0, 0, 0, 0] },
              ],
            ],
          },
          layout: "noBorders",
          margin: [0, 0, 0, 15],
        },

        // RODAPÉ COM INFORMAÇÕES
        {
          table: {
            widths: ["25%", "25%", "25%", "25%"],
            body: [
              [
                {
                  text: [
                    { text: "Transporte: ", bold: true, fontSize: 8 },
                    { text: transporteDescricao, fontSize: 8 },
                  ],
                },
                {
                  text: [
                    {
                      text: "Carta Fiança / Nota Promissória: ",
                      bold: true,
                      fontSize: 8,
                    },
                    { text: cartaFiancaNotaPromissoria, fontSize: 8 },
                  ],
                },
                {
                  text: [
                    { text: "Reajuste: ", bold: true, fontSize: 8 },
                    { text: reajusteDescricao, fontSize: 8 },
                  ],
                },
                {
                  text: [
                    { text: "Inspeção: ", bold: true, fontSize: 8 },
                    { text: inspecaoDescricao, fontSize: 8 },
                  ],
                },
              ],
              [
                {
                  text: [
                    { text: "Multa: ", bold: true, fontSize: 8 },
                    { text: multaDescricao || "-", fontSize: 8 },
                  ],
                },
                { text: "", fontSize: 8 },
                { text: "", fontSize: 8 },
                { text: "", fontSize: 8 },
              ],
            ],
          },
          layout: "noBorders",
          margin: [0, 0, 0, 10],
        },

        // LINHA FINAL
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 535,
              y2: 0,
              lineWidth: 0.5,
              lineColor: "#000000",
            },
          ],
          margin: [0, 0, 0, 5],
        },

        // DATA E PÁGINA
        {
          text: `Pág.: 1 - Emissão: ${dataEmissao}`,
          fontSize: 8,
          alignment: "right",
        },
      ],
    };
    
    console.log("docDef.images.logoImage:", docDef.images.logoImage ? docDef.images.logoImage.substring(0, 100) + "..." : "NULL");
    return docDef;
  }

  static criarLinhasItens(itens, tipoEquipamento) {
    const formatPercentValue = (value) => {
      if (value === null || value === undefined || value === "") return "";
      return value.toString();
    };

    const linhas = [];

    itens.forEach((item, index) => {
      // Linha principal do item
      linhas.push([
        { text: index + 1, fontSize: 7, alignment: "center" },
        {
          text: `${item.descricao || ""}\nCOD. ${item.codigo || ""}${item.tipoDeEquipamentoDescricao ? `\n[${item.tipoDeEquipamentoDescricao}]` : ""}`,
          fontSize: 7,
        },
        {
          text: item.quantidade || "0",
          fontSize: 7,
          alignment: "right",
        },
        {
          text: UtilMoney.toR$BRL(item.precoTotal || 0),
          fontSize: 7,
          alignment: "right",
        },
        {
          text: formatPercentValue(item.porcentagemIPI ?? item.IPI ?? item.valorIPI ?? ""),
          fontSize: 7,
          alignment: "center",
        },
        {
          text: formatPercentValue(item.porcentagemISS ?? item.ISS ?? item.valorISS ?? ""),
          fontSize: 7,
          alignment: "center",
        },
        {
          text: formatPercentValue(item.porcentagemICMS ?? item.ICMS ?? item.valorICMS ?? ""),
          fontSize: 7,
          alignment: "center",
        },
        {
          text: UtilMoney.toR$BRL(
            item.baseICMSISS ??
              item.baseICMS ??
              item.baseISS ??
              item.precoVenda_sIPI_sICMS ??
              0
          ),
          fontSize: 7,
          alignment: "right",
        },
        {
          text: item.dataPrazoEntregaFormatada || "",
          fontSize: 7,
          alignment: "center",
        },
        {
          text:
            item.classificacaoFiscalNCM ||
            item.classificacaoFiscal ||
            item.ncmCodigo ||
            item.ncm?.codigo ||
            "",
          fontSize: 7,
          alignment: "center",
        },
      ]);

      // Linhas dos subitens
      if (item.itens && Array.isArray(item.itens) && item.itens.length > 0) {
        item.itens.forEach((subitem) => {
          linhas.push([
            { text: `• ${subitem.sequencia || ""}`, fontSize: 6, alignment: "center" },
            {
              text: `${subitem.descricao || ""}\n`,
              fontSize: 6,
              margin: [10, 0, 0, 0],
            },
            {
              text: subitem.quantidade || "0",
              fontSize: 6,
              alignment: "right",
            },
            {
              text: UtilMoney.toR$BRL(subitem.valorTotal || 0),
              fontSize: 6,
              alignment: "right",
            },
            { text: "", fontSize: 6 },
            { text: "", fontSize: 6 },
            { text: "", fontSize: 6 },
            {
              text: UtilMoney.toR$BRL(subitem.valorTotal || 0),
              fontSize: 6,
              alignment: "right",
            },
            { text: "", fontSize: 6 },
            { text: "", fontSize: 6 },
          ]);
        });
      }
    });

    return linhas;
  }

  static criarLinhasPrazos(lancamentos) {
    return lancamentos.map((lancamento) => [
      { text: lancamento.dataVencimentoFormatada || "", fontSize: 8 },
      { text: lancamento.descricao || "", fontSize: 8 },
      {
        text: UtilMoney.toR$BRL(lancamento.valor || 0),
        fontSize: 8,
        alignment: "right",
      },
      { text: lancamento.dataLiquidacaoFormatada || "", fontSize: 8, alignment: "center" },
      {
        text: UtilMoney.toR$BRL(lancamento.valorPago || 0),
        fontSize: 8,
        alignment: "right",
      },
      {
        text:
          lancamento.dataUltimaAlteracaoFormatada ||
          lancamento.dataAlteracaoFormatada ||
          lancamento.dataUltAlteracaoFormatada ||
          "",
        fontSize: 8,
        alignment: "center",
      },
      {
        text: lancamento.status || lancamento.stat || "",
        fontSize: 8,
        alignment: "center",
      },
    ]);
  }
}

module.exports = UtilCapaJobPDF;
